// Module
var code = "Automated Member Payments are not yet enabled for your account. To find out more, contact Clubworx Support at <a href=\"mailto:support@clubworx.com\" target=\"_blank\">support@clubworx.com</a>. \n";
// Exports
module.exports = code;